import "./LoadingSpinner.css"

import React from "react"

export default function LoadingSpinner() {
  return <div className="tds-loading-spinner" />
}
